// Imports
import plansDetails, { Plan } from './plans-details';
import planMapping from '../../utils/billing/plan-mapping';
import { faBell, faComment } from '@fortawesome/pro-regular-svg-icons';


// Generate subscription plans that should be displayed
export function generateDisplayedPlans(displayDeluxePlan?: boolean): Plan[] {
	// Exclude grandfathered deluxe plan if not required
	if (!displayDeluxePlan) {
		return plansDetails.paidPlans;
	}
	
	
	// Look for relevant plans
	//  -> Avoids using magic numbers to directly index into the array
	const informPlan = plansDetails.paidPlans.find((plan) => plan.planNumber === planMapping.inform);
	
	const engagePlan = plansDetails.paidPlans.find((plan) => plan.planNumber === planMapping.engage);
	
	
	// Make TypeScript happy
	if (!informPlan || !engagePlan) {
		throw new Error(`Missing ${informPlan ? 'Engage plan' : 'Inform plan'}`);
	}
	
	
	// Inject grandfathered Deluxe plan and modify Engage plan
	return [
		informPlan,
		plansDetails.legacyPlan.grandfatheredDeluxePlan,
		{
			...engagePlan,
			features: {
				label: 'Everything in Deluxe, plus:',
				features: [
					{
						text: 'More text message credits',
						icon: faComment,
					},
					{
						text: 'Longer text messages',
						icon: faComment,
					},
					{
						text: 'Calendar event reminders',
						icon: faBell,
					},
				],
			},
		},
	];
}
